import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DragToSelectModule } from 'ngx-drag-to-select';
import { AppMaterialModule } from 'src/app/modules/app-material.module';
import { PipesModule } from 'src/app/modules/pipes/pipes.module';
import { BaseDialogComponent } from './components/base-dialog/base-dialog.component';
import { BaseListComponent } from './components/base-list/base-list.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { FavieAddressAutocompleteComponent } from './components/favie-address-autocomplete/favie-address-autocomplete.component';
import { FavieAutoCompleteComponent } from './components/favie-auto-complete/favie-auto-complete.component';
import { FaviePhoneComponent } from './components/favie-phone/favie-phone.component';
import { FavieSearchBarComponent } from './components/favie-search-bar/favie-search-bar.component';
import { FavieWebAdminHeaderComponent } from './components/header/components/favie-web-admin-header/favie-web-admin-header.component';
import { FavieUserMenuComponent } from './components/header/components/user-menu/user-menu.component';
import { HeaderComponent } from './components/header/header.component';
import { MainLayoutComponent } from './components/layouts/main-layout/main-layout.component';
import { PageContentLayoutComponent } from './components/layouts/page-content-layout/page-content-layout.component';
import { PageLayoutComponent } from './components/layouts/page-layout/page-layout.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { FavieUploadFileComponent } from './components/favie-upload-file/favie-upload-file.component';
import { PlainNumbersDirective } from './directives/plain-number.directive';
import { LocalSpinnerModule } from './modules/local-spinner/local-spinner.module';
import { DialogService } from './services/dialog/dialog.service';
import { FaviePaginatorComponent } from './components/favie-paginator/favie-paginator.component';
import { ButtonChatBoxComponent } from './components/button-chat-box/button-chat-box.component';
import { ChatBoxModule } from './modules/chat-box/chat-box.module';
import { AdditionalDocumentsComponent } from './components/additional-documents/additional-documents.component';

const components = [
  SidebarComponent,
  FavieWebAdminHeaderComponent,
  MainLayoutComponent,
  FavieUserMenuComponent,
  HeaderComponent,
  PageLayoutComponent,
  PageContentLayoutComponent,
  FaviePhoneComponent,
  FavieAddressAutocompleteComponent,
  FavieUploadFileComponent,
  BaseDialogComponent,
  FavieSearchBarComponent,
  FaviePaginatorComponent,
  BaseListComponent,
  FavieAutoCompleteComponent,
  ConfirmDialogComponent,
  ButtonChatBoxComponent,
  AdditionalDocumentsComponent,
];
const directives = [PlainNumbersDirective];
@NgModule({
  declarations: [...components, ...directives],
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    TranslateModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    AppMaterialModule,
    MatTableModule,
    DragToSelectModule.forRoot(),
    PipesModule,
    MatSortModule,
    ScrollingModule,
    LocalSpinnerModule,
    ChatBoxModule,
  ],
  exports: [...components, ...directives],
  providers: [DialogService],
})
export class SharedModule {}
